module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_1_5face.804f9824.jpg";